import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { FieldAdded } from 'src/app/core/models/application';
import { JsonFormControls, JsonFormData } from 'src/app/core/models/jobJsonForm';
import { ApplicationService } from 'src/app/core/services/application.service';
import { DeleteApplicationComponent } from '../delete-application/delete-application.component';
import { AddFieldComponent } from './add-field/add-field.component';

@Component({
  selector: 'app-build-form-json',
  templateUrl: './build-form-json.component.html',
  styleUrls: ['./build-form-json.component.scss']
})
export class BuildFormJsonComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<BuildFormJsonComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {depName: string, appName: string, appVer: string},
    private dialog: MatDialog,
    private applicationService: ApplicationService,
    private matSnackBar: MatSnackBar,
    private spiner: NgxSpinnerService
  ) { }

  fieldsAdded: FieldAdded[] = [
  ];
  depName = this.data.depName;
  appName = this.data.appName;
  appVer = this.data.appVer;

  ngOnInit(): void {
    this.spiner.show('buildform');
    this.loadFormData();
  }

  loadFormData(){
    this.applicationService.getJobJson(this.depName, this.appName, this.appVer).subscribe({
      next: (data: JsonFormData) => {
        if(data){
          data.Controls.forEach(control => {
            let obj : FieldAdded = {
              id: control.Id,
              uniqueName: control.Name,
              fieldName: control.Label,
              fieldValue: control.Value,
              isFieldRequired: control.Validators.Required,
              fieldType: control.Type
            }
            if(control.AddValue){
              obj.fieldValue = control.AddValue.toString();
            }
            this.fieldsAdded.push(obj);
          })
        }
        this.spiner.hide('buildform');
      }, error: (err) => {
        this.spiner.hide('buildform');
      }
    })
  }

  onClose(){
    this.applicationService.resetUniqueNames();
    this.dialogRef.close();
  }

  onSubmit(){
    let jsonObj : JsonFormData = {
      Controls: []
    }
    this.fieldsAdded.forEach(field => {
      let obj: JsonFormControls = {
        Id: field.id,
        Name: field.uniqueName,
        Label: field.fieldName,
        Type: field.fieldType,
        Value: field.fieldValue,
        ErrorMsg: field.errorMsg,
        Validators: {
          Required: field.isFieldRequired
        }
      }
      if(obj.Value ){
        if(typeof(obj.Value) == "boolean"){
          obj.Value = String(obj.Value);
        }
        obj.Value.trim();
      }
      if(field.fieldType == 'dropdown'){
        obj.Value = field.fieldValue.split(',')[0],
        obj.AddValue = field.fieldValue.split(',')
      }
      if(field.fieldType == 'checkbox'){
        obj.Validators.Required = true;
      }
      jsonObj.Controls.push(obj);
    });
    this.applicationService.resetUniqueNames();
    this.applicationService.updateJobJson(this.depName, this.appName, this.appVer, jsonObj).subscribe({
      next: (data: any) => {
        this.matSnackBar.open(data.actionMessage, 'Ok', {
          duration: 5000
        })
      }, error: (err) => {
        this.matSnackBar.open(err.error.actionMessage, 'Ok', {
          duration: 5000
        })
      }
    });
    this.dialogRef.close();
  }

  addNewField(obj?: FieldAdded){
    this.fieldsAdded.forEach(field => {
      this.applicationService.updateAddedUniqueNames(field.uniqueName);
    });
    let newId = Math.max(...this.fieldsAdded.map(o => o.id));
    if(newId == -Infinity){
      newId = 0;
    }
    const addDialog = this.dialog.open(AddFieldComponent,{
      autoFocus: false,
      disableClose: true,
      width: '500px',
      data: { editObj : obj, fieldAdded: newId }
    });
    addDialog.afterClosed().subscribe((res)=> {
      if(res){
        let idx = this.fieldsAdded.findIndex(field => field.id == res.id );
        if(idx == -1){
          this.fieldsAdded.push(res);
          this.applicationService.updateAddedUniqueNames(res.uniqueName);
        } else {
          this.fieldsAdded[idx] = res;
        }
      }
    })
  }

  onEdit(obj: FieldAdded){
    this.addNewField(obj)
  }

  onDelete(obj: FieldAdded){
    const dialogRef = this.dialog.open(DeleteApplicationComponent, {
      disableClose: true,
      autoFocus: false,
      width: '400px',
      data: { title: 'Delete Field', content: 'Do you want to delete the field ?' }
    })

    dialogRef.afterClosed().subscribe(res => {
      if(res){
        let idx = this.fieldsAdded.findIndex(field => field.id == obj.id)
        this.fieldsAdded.splice(idx,1);
        this.applicationService.removeUniqueName(this.fieldsAdded[idx].fieldName)
      }
    })
  }
}
